import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="polling"
export default class extends Controller {
  static targets = ["frame", "finished", "placeholder"]
  static values = {
    interval: { type: Number, default: 3000 },
    noReload: { type: Boolean, default: false }
  }

  connect() {
    if (!this.hasFrameTarget) return
    this.poll = setInterval(() => {
      this.frameTarget.reload()
    }, this.intervalValue)
  }

  disconnect() {
    clearInterval(this.poll)
  }

  finishedTargetConnected() {
    if (!this.hasFrameTarget) return
    clearInterval(this.poll)
    if (!this.noReloadValue) {
      Turbo.visit(window.location.href, { action: "replace" })
    }
  }
}
